import { render, staticRenderFns } from "./predefine.vue?vue&type=template&id=9f85ccbe&"
import script from "./predefine.vue?vue&type=script&lang=js&"
export * from "./predefine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports